import { render, staticRenderFns } from "./EditResourceInformationModalNew.vue?vue&type=template&id=2506b9f3&scoped=true"
import script from "./EditResourceInformationModalNew.vue?vue&type=script&lang=ts"
export * from "./EditResourceInformationModalNew.vue?vue&type=script&lang=ts"
import style0 from "./EditResourceInformationModalNew.vue?vue&type=style&index=0&id=2506b9f3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2506b9f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2506b9f3')) {
      api.createRecord('2506b9f3', component.options)
    } else {
      api.reload('2506b9f3', component.options)
    }
    module.hot.accept("./EditResourceInformationModalNew.vue?vue&type=template&id=2506b9f3&scoped=true", function () {
      api.rerender('2506b9f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/EditResourceInformationModalNew.vue"
export default component.exports